"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rangeIntersect = exports.rangeContains = exports.randomVec = exports.randomRange = exports.randomRGBOpacity = exports.randomRGBA = exports.randomRGB = exports.randomInt = exports.norm = exports.map = exports.lerpVec = exports.lerp = exports.inRange = exports.inRads = exports.inDegr = exports.clamp = void 0;

var _victor = _interopRequireDefault(require("victor"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Vector = _victor.default;

const norm = (value, min, max) => {
  return (value - min) / (max - min);
};

exports.norm = norm;

const lerp = (norm, min, max) => {
  return (max - min) * norm + min;
};

exports.lerp = lerp;

const lerpVec = (norm, v0, v1) => {
  const x = (v1.x - v0.x) * norm + v0.x;
  const y = (v1.y - v0.y) * norm + v0.y;
  return new Vector(x, y);
};

exports.lerpVec = lerpVec;

const map = (value, sourceMin, sourceMax, destMin, destMax) => {
  const n = norm(value, sourceMin, sourceMax);
  return lerp(n, destMin, destMax);
};

exports.map = map;

const clamp = (value, min, max) => {
  return Math.min(Math.max(value, Math.min(min, max)), Math.max(min, max));
};

exports.clamp = clamp;

const inRads = degr => {
  return degr / 180 * Math.PI;
};

exports.inRads = inRads;

const inDegr = rads => {
  return rads * 180 / Math.PI;
};

exports.inDegr = inDegr;

const inRange = (value, min, max) => {
  return value >= Math.min(min, max) && value <= Math.max(min, max);
};

exports.inRange = inRange;

const rangeIntersect = (min0, max0, min1, max1) => {
  return Math.max(min0, max0) >= Math.min(min1, max1) && Math.min(min0, max0) <= Math.min(min1, max1);
};

exports.rangeIntersect = rangeIntersect;

const rangeContains = (min0, max0, min1, max1) => {
  return Math.max(min0, max0) >= Math.max(min1, max1) && Math.min(min0, max0) <= Math.min(min1, max1);
};

exports.rangeContains = rangeContains;

const randomRange = (min, max) => {
  return min + Math.random() * (max - min);
};

exports.randomRange = randomRange;

const randomInt = (min, max) => {
  return Math.floor(min + Math.random() * (max - min));
};

exports.randomInt = randomInt;

const randomVec = () => {
  let vec = [randomRange(-1, 1), randomRange(-1, 1)];
  let len = Math.sqrt(vec[0] * vec[0] + vec[1] * vec[1]);

  if (len == 0) {
    vec = [1, 0];
    len = 1;
  }

  return new Vector(vec[0] / len, vec[1] / len);
};

exports.randomVec = randomVec;

const randomRGB = () => {
  return "rgb(" + randomInt(0, 255) + "," + randomInt(0, 255) + "," + randomInt(0, 255) + ")";
};

exports.randomRGB = randomRGB;

const randomRGBA = () => {
  return "rgba(" + randomInt(0, 255) + "," + randomInt(0, 255) + "," + randomInt(0, 255) + "," + randomRange(0.0, 1.0) + ")";
};

exports.randomRGBA = randomRGBA;

const randomRGBOpacity = () => {
  return "rgba(" + randomInt(0, 255) + "," + randomInt(0, 255) + "," + randomInt(0, 255) + "," + clamp(opacity, 0.0, 1.0) + ")";
};

exports.randomRGBOpacity = randomRGBOpacity;